module.exports = __webpack_public_path__ + "static/media/exit.b2e867f6.png";